import type { Guide, GuideRecordHint } from '../types';

/** S-21.10-09 — rejestr zmiany zlecenia „było → ma być” (scenariusz e2e 16, ścieżki MIX-02, ADM-04). */
const TMS_ORDER: GuideRecordHint = {
  description: 'dowolne zlecenie z TMS — najlepiej zaplanowane (obsadzone autem albo przewoźnikiem)',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

export const guide: Guide = {
  flagKey: 'orderChangeRegister',
  title: 'Rejestr zmiany zlecenia „było → ma być”',
  whatItDoes:
    'CS albo osoba realizująca zgłasza na karcie zlecenia zmianę: okno załadunku lub rozładunku, miejsce, wagę, LDM, stawkę albo uwagi — „było” bierzemy z danych zlecenia, „ma być” wpisuje zgłaszający, z powodem. O zmianie decydują wskazane osoby, potem przyjmujący zlecenia wprowadza ją w TMS ręcznie i oznacza „Wprowadzone w TMS”. Import z TMS zamyka zmianę, gdy dane się zgadzają; aplikacja do TMS nic nie zapisuje.',
  audience: ['CS', 'Administracja', 'planista FTL', 'Trade'],
  presentationItems: ['S-21.10-09'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: TMS_ORDER,
      target: 'order-changes-section',
      title: 'Sekcja „Zmiany zlecenia”',
      description:
        'Na karcie zlecenia z TMS: zgłoszone zmiany z „było → ma być”, kto decyduje i stan każdej z nich.',
      action: 'Otwórz zlecenie i znajdź sekcję „Zmiany zlecenia (było → ma być)”.',
      recorder: { account: 'cs', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TMS_ORDER,
      target: 'order-change-report-save',
      title: 'Zgłoszenie zmiany',
      description:
        'W oknie wybierasz, co się zmienia, wpisujesz nową wartość i powód ze źródłem (np. mail klienta). „Było” system bierze z danych zlecenia.',
      action: 'Kliknij „Zgłoś zmianę”, wybierz pole, wpisz wartość i powód, potem „Zgłoś zmianę”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'order', number: 'DEMO/2026/10/H03' },
        actions: [
          { kind: 'click', target: 'order-change-report' },
          { kind: 'select', label: 'Co się zmienia', option: 'Waga' },
          { kind: 'fill', target: 'order-change-value', value: '23500' },
          { kind: 'fill', target: 'order-change-reason', value: 'Mail klienta: korekta wagi do 23,5 t.' },
        ],
      },
    },
    {
      route: '/order-changes',
      target: 'order-change-list',
      mockupTestId: 'adm-zmiana-akceptuj',
      title: 'Lista „Zmiany zleceń”',
      description:
        'Wszystkie zgłoszone zmiany w jednym miejscu. Po akceptacji przyjmujący zlecenia wprowadza zmianę w TMS i klika „Wprowadzone w TMS”; gdy import pokaże inną wartość — przypomnienie przy zmianie.',
      action: 'Otwórz „Zmiany zleceń” w menu, przy zaakceptowanej zmianie kliknij „Wprowadzone w TMS”.',
      recorder: { account: 'adm' },
    },
    {
      route: '/intake-dashboard',
      target: 'intake-tile-changesToEnter',
      title: 'Zmiany na pulpicie przyjęcia zleceń',
      description:
        'Pulpit liczy zmiany czekające na decyzję, zaakceptowane do wprowadzenia w TMS i te, przy których TMS pokazuje co innego niż „ma być”.',
      action: 'Kliknij kafelek, żeby otworzyć listę zmian z tym samym filtrem.',
      recorder: { account: 'adm' },
    },
  ],
};
